<template>
  <ComplianceLayout page="contact">
    <h1>Contact Us</h1>
    <p>We welcome feedback, corrections, and general inquiries related to this website.</p>
    <p>You may contact us for:</p>
    <ul>
      <li>Content corrections</li>
      <li>Technical issues</li>
      <li>Copyright concerns</li>
      <li>General feedback</li>
      <li>Business inquiries</li>
    </ul>
    <h2>Email</h2>
    <p><a href="mailto:support@appsgb.org">support@appsgb.org</a></p>
    <h2>Response Time</h2>
    <p>We usually respond within 3–5 business days.</p>
    <h2>Important Notice</h2>
    <p>This website is an independent informational platform and does not provide official WhatsApp or Meta support services.</p>
  </ComplianceLayout>
</template>

<script>
import ComplianceLayout from '@/components/ComplianceLayout.vue';

export default {
  name: 'ContactPage',
  components: {
    ComplianceLayout,
  },
};
</script>
